import {
  Image,
  Heading,
  LinkWithButtonStyles,
} from '@frontendmentorio/design-system-v2';

export default function Companies() {
  return (
    <div className="bg-neutralWhite px-5 desktop:py-6">
      <div className="container-xl flex flex-col items-start gap-7 tablet:!w-max desktop:gap-8 desktop:items-center desktop:!w-full">
        <Heading
          className="max-w-[20ch] desktop:text-center"
          level="4"
          tagName="h2"
        >
          For companies
        </Heading>

        <div className="flex flex-col gap-6 tablet:max-w-prose desktop:flex-row-reverse desktop:gap-7 desktop:items-center desktop:max-w-none">
          <Image
            alt="Frontend Mentor for Teams platform interface showing project management for engineering teams"
            className="desktop:w-1/2"
            height={964}
            src="/static/images/home-teams.webp"
            width={1160}
          />

          <div className="flex flex-col gap-5 desktop:gap-6 desktop:w-1/2">
            <div className="flex flex-col gap-4">
              <Heading
                className="font-secondary italic text-lg text-blue-500"
                level="2"
                tagName="span"
              >
                Engineering teams
              </Heading>

              <Heading level="3" tagName="h3">
                Train junior developers with real projects
              </Heading>
            </div>

            <p className="text-lg text-neutral-500">
              Skip theoretical tutorials. Give your junior developers 100+
              real-world challenges that build practical skills faster than
              traditional training programs.
            </p>

            <LinkWithButtonStyles
              href={process.env.NEXT_PUBLIC_TEAMS_PLATFORM_URL}
            >
              Explore teams
            </LinkWithButtonStyles>
          </div>
        </div>

        <div className="flex flex-col gap-6 tablet:max-w-prose desktop:flex-row desktop:gap-7 desktop:items-center desktop:max-w-none">
          <Image
            alt="Frontend Mentor Hiring platform interface showing developer profiles and skills assessment"
            className="desktop:w-1/2"
            height={961}
            src="/static/images/home-hiring.webp"
            width={1164}
          />

          <div className="flex flex-col gap-5 desktop:gap-6 desktop:w-1/2">
            <div className="flex flex-col gap-4">
              <Heading
                className="font-secondary italic text-lg text-blue-500"
                level="2"
                tagName="span"
              >
                Hiring teams
              </Heading>

              <Heading level="3" tagName="h3">
                Discover junior talent through skills, not resumes
              </Heading>
            </div>

            <p className="text-lg text-neutral-500">
              See real code and live projects upfront, then connect directly
              with developers who've demonstrated the skills and passion you
              need.
            </p>

            <LinkWithButtonStyles
              href={process.env.NEXT_PUBLIC_HIRING_PLATFORM_URL}
            >
              Explore hiring
            </LinkWithButtonStyles>
          </div>
        </div>
      </div>
    </div>
  );
}
